import type { ChatSituationId } from "./learning-chat-situations.js";

export type ChatPhase = "greeting" | "thinking" | "clarify" | "result";

export type ThreadMessage =
  | { id: string; kind: "user"; text: string }
  | { id: string; kind: "status"; seconds: number; stepKey: string }
  | { id: string; kind: "assistant"; text: string };

export type ChatSession = {
  id: string;
  title: string;
  dateKey: string;
  messages: ThreadMessage[];
  phase: ChatPhase;
  clarifyStep: 0 | 1;
  situationId?: ChatSituationId;
};

export type ResultCardId = "summary" | "goal" | "attention" | "prepare" | "keepInMind" | "afterwards";

export const THINKING_MS = 1600;

export const clarifyOptionIds = ["1", "2", "3", "4", "5"] as const;

export function createSessionId(): string {
  return `chat-${Date.now()}`;
}

export function todayDateKey(): string {
  return new Date().toISOString().slice(0, 10);
}

export function focusGreetingSession(topic: string, greeting: string): ChatSession {
  return {
    id: createSessionId(),
    title: topic,
    dateKey: todayDateKey(),
    clarifyStep: 0,
    phase: "greeting",
    messages: [{ id: `assistant-greeting-${topic}`, kind: "assistant", text: greeting }],
  };
}

export function replyToGreeting(session: ChatSession, text: string): ChatSession {
  return {
    ...session,
    title: text,
    phase: "thinking",
    messages: [
      ...session.messages,
      { id: `user-${Date.now()}`, kind: "user", text },
      {
        id: `status-${Date.now()}`,
        kind: "status",
        seconds: 12,
        stepKey: "learningRoute.chatThinkingSteps.understand",
      },
    ],
  };
}
